import { render, staticRenderFns } from "./CadriDataTable.vue?vue&type=template&id=785e6812&scoped=true"
import script from "./CadriDataTable.vue?vue&type=script&lang=js"
export * from "./CadriDataTable.vue?vue&type=script&lang=js"
import style0 from "./CadriDataTable.vue?vue&type=style&index=0&id=785e6812&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e6812",
  null
  
)

export default component.exports